import ContentLayout from "../components/layout/ContentLayout";
import { Button, Form, Input, message, Select, Space, TimePicker } from "antd";
// import Button from "../components/Button";
import LocationPicker from "../components/LocationPicker";
import MyModal from "../components/MyModal";
import { useRef, useState } from "react";
import { createOutlet } from "../actions/acc_actions";
import dayjs from "dayjs";
import { daysOfWeek } from "../utils/functions";

import customParseFormat from "dayjs/plugin/customParseFormat";
import { useParams } from "react-router-dom";
dayjs.extend(customParseFormat);

export default function Outlets() {
  const { businessUrn } = useParams();
  const [form] = Form.useForm();
  const modalRef = useRef();

  const [isLoading, setIsLoading] = useState();

  const onFinish = (values) => {
    const formattedTimes = values.opening_times
      .map(({ day, time }) => {
        const [start, end] = time;
        return `${day}: ${dayjs(start).format("HH:mm")}-${dayjs(end).format(
          "HH:mm"
        )}`;
      })
      .join(", ");

    const data = {
      name: values.name,
      address: {
        house_number: values.house_number,
        street_name: values.street_name,
        town: values.town,
        postal_code: values.postal_code,
      },
      location: { lat: values.lat + "", long: values.lng + "" },
      opening_times: formattedTimes,
    };
    setIsLoading(true);

    createOutlet(data, businessUrn)
      .then(() => {
        modalRef.current.showModal(); // Open the modal
      })
      .catch(() => {
        message.error("Something went Wrong !!");
      });

    setIsLoading(false);
  };
  return (
    <ContentLayout
      header={
        <>
          <h1>
            Welcome to <span>Outlets</span>
          </h1>
          <p className="content_layout-subtitle">Add Your Outlets</p>
        </>
      }
    >
      <div className="rewards-form-container">
        <Form
          form={form}
          className="rewards-form"
          onFinish={onFinish}
          layout="vertical"
        >
          <div className="rewards-form-section">
            <h4>Details</h4>
            <div className="rewards-inputs">
              <Form.Item
                name="name"
                label="Outlet Name"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </div>
          </div>
          <div className="rewards-form-section">
            <h4 style={{ marginTop: 5 }}>Location</h4>
            <div className="rewards-inputs">
              <div className="form-row">
                <Form.Item
                  name="house_number"
                  label="House Number"
                  rules={[{ required: true }]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="street_name"
                  label="Street Name"
                  rules={[{ required: true }]}
                >
                  <Input />
                </Form.Item>
              </div>
              <div>
                <Form.Item
                  name="town"
                  label="Town"
                  rules={[{ required: true }]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="postal_code"
                  label="Postal code"
                  rules={[{ required: true }]}
                >
                  <Input />
                </Form.Item>
              </div>

              <LocationPicker form={form} />
            </div>
          </div>
          <Form.List name="opening_times">
            {(fields, { add, remove }) => (
              <div className="rewards-form-section">
                <h4 style={{ marginTop: 5 }}>Appointments</h4>
                <div className="rewards-inputs">
                  {fields.map((field, index) => (
                    <Space
                      key={index}
                      style={{ display: "flex", marginBottom: 8 }}
                      align="baseline"
                    >
                      <Form.Item
                        {...field}
                        name={[field.name, "day"]}
                        rules={[{ required: true, message: "Select day" }]}
                      >
                        <Select
                          placeholder="Day"
                          options={daysOfWeek}
                          style={{ width: 120 }}
                        />
                      </Form.Item>

                      <Form.Item
                        {...field}
                        name={[field.name, "time"]}
                        rules={[
                          { required: true, message: "Select time range" },
                        ]}
                      >
                        <TimePicker.RangePicker format="HH:mm" />
                      </Form.Item>

                      <Button
                        danger
                        onClick={() => remove(field.name)}
                        type="dashed"
                      >
                        Remove
                      </Button>
                    </Space>
                  ))}

                  <Form.Item>
                    <Button type="dashed" onClick={() => add()} block icon="+">
                      Add Day & Time
                    </Button>
                  </Form.Item>
                </div>
              </div>
            )}
          </Form.List>
          <Form.Item className="rewards-form-btn">
            <Button
              htmlType="submit"
              type="primary"
              loading={isLoading}
              className={isLoading ? "loading" : null}
              style={{ width: "14rem" }}
            >
              {isLoading ? "loading" : "Add"}
            </Button>
          </Form.Item>
        </Form>
      </div>
      <MyModal
        ref={modalRef}
        title="Outlet Added Successful"
        message="Your Outlet Details Has Been Succefully Added and is ready"
        imageSrc="/assets/images/modal/stamp.png"
        confirmText="Back to Outlets"
        navigatePath={-1}
      />
    </ContentLayout>
  );
}
